module.exports = __webpack_public_path__ + "img/no_result4.641ec4f5.png";